import { CSSProperties, memo, PropsWithChildren } from 'react';

import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

import styles from './SortableCardItem.module.scss';

interface IProps {
  id: UniqueIdentifier;
  overlay?: boolean;
  size?: 's' | 'l';
}

export const SortableCardItem = memo<PropsWithChildren<IProps>>(
  ({ id, children, overlay, size }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging: dragging,
      isSorting: sorting,
    } = useSortable({
      id,
      data: {
        type: 'Shortcut',
      },
    });

    if (dragging) {
      return (
        <button
          ref={setNodeRef}
          data-onboarding-shortcut-id={String(id)}
          className={classNames(
            styles.item,
            dragging && styles.dragging,
            sorting && styles.sorting,
            size && styles[size]
          )}
          style={
            {
              transform: CSS.Transform.toString(transform),
              transition,
            } as CSSProperties
          }
          {...listeners}
          {...attributes}
        >
          {children}
        </button>
      );
    }

    return (
      <button
        ref={setNodeRef}
        data-onboarding-shortcut-id={String(id)}
        className={classNames(
          styles.item,
          dragging && styles.dragging,
          sorting && styles.sorting,
          overlay && styles.overlay,
          size && styles[size]
        )}
        style={
          {
            transform: CSS.Transform.toString(transform),
            transition,
          } as CSSProperties
        }
        {...listeners}
        {...attributes}
      >
        {children}
      </button>
    );
  }
);
